import {
   randNumber,
   randFullName,
   randCompanyName,
   randStreetAddress,
   randStreetName,
   randCity,
   randZipCode,
   randPhoneNumber,
   randEmail,
} from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { MockCountry, Region } from './countries.mock';
import { BillingParty } from '../base';

export class MockBillingParty extends BillingParty {
   constructor() {
      super();

      this.id = randNumber();
      this.name = randCompanyName();
      this.address1 = randStreetAddress();
      if ( optional() ) { this.address2 = randStreetName(); }
      if ( optional() ) { this.address3 = randStreetName(); }
      this.city = randCity();
      this.postalcode = randZipCode();

      const country = MockCountry();
      this.country = country.code;
      if ( optional() ) { this.state = Region().code; }
      if ( optional() ) { this.postalcode = randZipCode(); }

      if ( optional() ) { this.phone = randPhoneNumber({ countryCode: country.code as any }).slice( 0, 25 ); }
      if ( optional() ) { this.fax = randPhoneNumber({ countryCode: country.code as any }).slice( 0, 25 ); }
      if ( optional() ) { this.email = randEmail(); }
      if ( optional() ) {
         this.contact = ({
            name: randFullName(),
            phone: randPhoneNumber().slice( 0, 25 )
         });
      }
   }
}
